// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QpVD3qAS0nYBtoQqAYoe {
  border-radius: 30px;
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
  z-index: 2000;
  opacity: 1;
  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
}
.QpVD3qAS0nYBtoQqAYoe.pGuXSjiAF9ReSU4SwCSk {
  opacity: 0;
  transform: translateY(-100%);
}
.QpVD3qAS0nYBtoQqAYoe .IN1dAZkGN8YgIc1_f2FV {
  display: flex;
  justify-content: center;
  align-items: center;
}
.QpVD3qAS0nYBtoQqAYoe .o5xAJUHc5NRtb6zPAGtC {
  display: flex;
  justify-content: center;
  width: auto;
  height: 3.5rem;
  list-style: none;
  padding: 0;
  margin: 0;
  border-radius: 0.75rem;
}
.QpVD3qAS0nYBtoQqAYoe .o5xAJUHc5NRtb6zPAGtC a {
  position: relative;
  color: whitesmoke;
  text-decoration: none;
  padding: 0.5rem 1rem;
  font-weight: 500;
  font-size: 1.7rem;
  transition: color 0.3s ease, transform 0.3s ease;
}
.QpVD3qAS0nYBtoQqAYoe .o5xAJUHc5NRtb6zPAGtC a:hover {
  color: #242c56;
  transform: scale(1.05);
}
.QpVD3qAS0nYBtoQqAYoe .o5xAJUHc5NRtb6zPAGtC a:before {
  content: "";
  position: absolute;
  width: 90%;
  height: 2px;
  background-color: #242c56;
  bottom: 0;
  left: 0;
  transform: scaleX(0);
  transform-origin: center;
  margin-left: 0.7rem;
  transition: transform 0.3s ease-in-out;
  box-shadow: 0 2px 8px rgba(245, 245, 245, 0.25);
}
.QpVD3qAS0nYBtoQqAYoe .o5xAJUHc5NRtb6zPAGtC a:hover:before {
  transform: scaleX(0.75);
}
.QpVD3qAS0nYBtoQqAYoe .o5xAJUHc5NRtb6zPAGtC a li {
  margin-left: 0.5rem;
  cursor: pointer;
}
.QpVD3qAS0nYBtoQqAYoe .ZcrcTrKhDDmmbAOeAxJJ {
  display: none;
  flex-direction: column;
  cursor: pointer;
  transition: 0.3s ease;
  width: 80vw;
}
.QpVD3qAS0nYBtoQqAYoe .ZcrcTrKhDDmmbAOeAxJJ span {
  background: #fff;
  height: 2.5px;
  border-radius: 15%;
  width: 25px;
  margin: 2px 0;
  transition: 0.3s ease;
}
.QpVD3qAS0nYBtoQqAYoe .EHyE2pRSdW8SxXlsnalc {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: #130013;
  position: absolute;
  top: 100%;
  width: 100vw;
}
.QpVD3qAS0nYBtoQqAYoe .B0N_SpgrkQDn_a8SbL4n {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
}
.QpVD3qAS0nYBtoQqAYoe .B0N_SpgrkQDn_a8SbL4n a {
  display: block;
  width: 100vw;
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.5rem;
  padding: 1.5rem 0;
  text-align: center;
  transition: color 0.3s ease, background-color 0.3s ease;
}
.QpVD3qAS0nYBtoQqAYoe .B0N_SpgrkQDn_a8SbL4n a:hover {
  color: white;
  background-color: #242c56;
  text-shadow: 0 0 2px ghostwhite, 0 0 4px ghostwhite, 0 0 6px ghostwhite;
}
.QpVD3qAS0nYBtoQqAYoe .B0N_SpgrkQDn_a8SbL4n a li {
  cursor: pointer;
}
@media (max-width: 768px) {
  .QpVD3qAS0nYBtoQqAYoe .o5xAJUHc5NRtb6zPAGtC {
    display: none;
    visibility: hidden;
    height: 0;
  }
  .QpVD3qAS0nYBtoQqAYoe .ZcrcTrKhDDmmbAOeAxJJ {
    display: flex;
    margin-top: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar/NavBar.module.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;EACA,UAAA;EACA,gEAAA;AACJ;AACI;EACE,UAAA;EACA,4BAAA;AACN;AAEI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AAGI;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;AADN;AAGM;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;AADR;AAGQ;EACE,cAAA;EACA,sBAAA;AADV;AAIQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;EACA,OAAA;EACA,oBAAA;EACA,wBAAA;EACA,mBAAA;EACA,sCAAA;EACA,+CAAA;AAFV;AAKQ;EACE,uBAAA;AAHV;AAMQ;EACE,mBAAA;EACA,eAAA;AAJV;AASI;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AAPN;AASM;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;AAPR;AAWI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;AATN;AAYI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAVN;AAYM;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uDAAA;AAVR;AAYQ;EACE,YAAA;EACA,yBAAA;EACA,uEAAA;AAVV;AAaQ;EACE,eAAA;AAXV;AAgBI;EACE;IACE,aAAA;IACA,kBAAA;IACA,SAAA;EAdN;EAiBI;IACE,aAAA;IACA,gBAAA;EAfN;AACF","sourcesContent":[".NavBar {\n    border-radius: 30px;\n    padding: 1rem 2rem;\n    position: sticky;\n    top: 0;\n    z-index: 2000;\n    opacity: 1;\n    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;\n  \n    &.hidden {\n      opacity: 0;\n      transform: translateY(-100%);\n    }\n  \n    .NavBarContainer {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  \n    .NavList {\n      display: flex;\n      justify-content: center;\n      width: auto;\n      height: 3.5rem;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      border-radius: 0.75rem;\n  \n      a {\n        position: relative;\n        color: whitesmoke;\n        text-decoration: none;\n        padding: 0.5rem 1rem;\n        font-weight: 500;\n        font-size: 1.7rem;\n        transition: color 0.3s ease, transform 0.3s ease;\n  \n        &:hover {\n          color: #242c56;\n          transform: scale(1.05);\n        }\n  \n        &:before {\n          content: '';\n          position: absolute;\n          width: 90%;\n          height: 2px;\n          background-color: #242c56;\n          bottom: 0;\n          left: 0;\n          transform: scaleX(0);\n          transform-origin: center;\n          margin-left: 0.7rem;\n          transition: transform 0.3s ease-in-out;\n          box-shadow: 0 2px 8px rgba(245, 245, 245, 0.25);\n        }\n  \n        &:hover:before {\n          transform: scaleX(0.75);\n        }\n  \n        li {\n          margin-left: 0.5rem;\n          cursor: pointer;\n        }\n      }\n    }\n  \n    .Hamburger {\n      display: none;\n      flex-direction: column;\n      cursor: pointer;\n      transition: 0.3s ease;\n      width: 80vw;\n  \n      span {\n        background: #fff;\n        height: 2.5px;\n        border-radius: 15%;\n        width: 25px;\n        margin: 2px 0;\n        transition: 0.3s ease;\n      }\n    }\n  \n    .MobileMenu {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: flex-start; \n      background: #130013;\n      position: absolute;\n      top: 100%;\n      width: 100vw;\n    }\n  \n    .MobileNavList {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n  \n      a {\n        display: block;\n        width: 100vw;\n        color: #fff;\n        text-decoration: none;\n        font-weight: 500;\n        font-size: 1.5rem;\n        padding: 1.5rem 0; \n        text-align: center;\n        transition: color 0.3s ease, background-color 0.3s ease;\n  \n        &:hover {\n          color: white;\n          background-color: #242c56;\n          text-shadow: 0 0 2px ghostwhite, 0 0 4px ghostwhite, 0 0 6px ghostwhite;\n        }\n  \n        li {\n          cursor: pointer;\n        }\n      }\n    }\n  \n    @media (max-width: 768px) {\n      .NavList {\n        display: none;\n        visibility: hidden;\n        height: 0;\n      }\n  \n      .Hamburger {\n        display: flex;\n        margin-top: 10px;\n      }\n    }\n  }  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NavBar": `QpVD3qAS0nYBtoQqAYoe`,
	"hidden": `pGuXSjiAF9ReSU4SwCSk`,
	"NavBarContainer": `IN1dAZkGN8YgIc1_f2FV`,
	"NavList": `o5xAJUHc5NRtb6zPAGtC`,
	"Hamburger": `ZcrcTrKhDDmmbAOeAxJJ`,
	"MobileMenu": `EHyE2pRSdW8SxXlsnalc`,
	"MobileNavList": `B0N_SpgrkQDn_a8SbL4n`
};
export default ___CSS_LOADER_EXPORT___;
